"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = exports.LargeScreenTitle = exports.Wrapper = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const Grid_1 = __importDefault(require("../grid/Grid"));
const PREFIX = "SignupBlock";
exports.classes = {
    signupLabel: `${PREFIX}-signupLabel`
};
exports.Wrapper = (0, styles_1.styled)("div")(() => ({
    padding: "30px 0",
    [`.${exports.classes.signupLabel}`]: {
        width: "100%"
    }
}));
exports.LargeScreenTitle = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    [theme.breakpoints.up("lg")]: { marginBottom: "24px" }
}));
exports.ButtonContainer = (0, styles_1.styled)(Grid_1.default)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NpZ251cC1ibG9jay9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLCtEQUF1QztBQUN2Qyx3REFBZ0M7QUFFaEMsTUFBTSxNQUFNLEdBQUcsYUFBYSxDQUFDO0FBRWhCLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLFdBQVcsRUFBRSxHQUFHLE1BQU0sY0FBYztDQUNyQyxDQUFDO0FBRVcsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQztJQUMxQyxPQUFPLEVBQUUsUUFBUTtJQUNqQixDQUFDLElBQUksZUFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7UUFDM0IsS0FBSyxFQUFFLE1BQU07S0FDZDtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxnQkFBZ0IsR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2pFLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRSxFQUFFLFlBQVksRUFBRSxNQUFNLEVBQUU7Q0FDdkQsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLGVBQWUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQztJQUMxQyxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLGNBQWMsRUFBRSxRQUFRO0NBQ3pCLENBQUMsQ0FBQyJ9